// extensions/FontFamily.js
import TextStyle from "@tiptap/extension-text-style";

const FontFamily = TextStyle.extend({
  name: "fontFamily",

  addAttributes() {
    return {
      fontFamily: {
        default: null,
        parseHTML: (element) => element.style.fontFamily?.replace(/['"]/g, ""),
        renderHTML: (attributes) => {
          if (!attributes.fontFamily) return {};
          return {
            style: `font-family: ${attributes.fontFamily}`,
          };
        },
      },
    };
  },

  addCommands() {
    return {
      setFontFamily:
        (fontFamily) =>
        ({ chain }) => {
          return chain().setMark("fontFamily", { fontFamily }).run();
        },
    };
  },
});

export default FontFamily;
